export const jobListings = [
  {
    id: 1,
    title: 'Project Manager Konstruksi',
    department: 'Manajemen Proyek',
    location: 'Jakarta Selatan',
    type: 'Full-time',
    level: 'Senior',
    salary: 'Rp 15.000.000 – 25.000.000',
    deadline: '30 April 2026',
    description: 'Memimpin dan mengelola proyek konstruksi skala besar dari perencanaan hingga serah terima. Bertanggung jawab atas jadwal, anggaran, mutu, dan koordinasi seluruh tim lapangan serta subkontraktor.',
    requirements: [
      'Minimal S1 Teknik Sipil / Arsitektur',
      'Pengalaman minimal 7 tahun di bidang konstruksi',
      'Memiliki sertifikasi SKA Muda / Madya',
      'Mahir menggunakan MS Project & Primavera',
      'Kemampuan komunikasi dan negosiasi yang baik',
      'Mampu bekerja di bawah tekanan dan target',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Tunjangan Transportasi', 'Bonus Proyek', 'Asuransi Jiwa'],
    tags: ['PM', 'Konstruksi', 'Senior'],
  },
  {
    id: 2,
    title: 'BIM Specialist / Modeler',
    department: 'Teknologi & Inovasi',
    location: 'Jakarta Selatan',
    type: 'Full-time',
    level: 'Mid-Level',
    salary: 'Rp 10.000.000 – 16.000.000',
    deadline: '15 Mei 2026',
    description: 'Membuat dan mengelola model BIM (Building Information Modeling) untuk proyek konstruksi gedung dan infrastruktur. Berkolaborasi dengan tim desain, engineering, dan kontraktor dalam lingkungan BIM.',
    requirements: [
      'Minimal S1 Teknik Sipil / Arsitektur',
      'Pengalaman 3+ tahun menggunakan Autodesk Revit & Navisworks',
      'Memahami standar BIM Level 2/3',
      'Familiar dengan clash detection dan 4D/5D BIM',
      'Menguasai AutoCAD, Dynamo, dan Civil 3D',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Tunjangan Pendidikan', 'Remote Work Hybrid', 'Pelatihan Sertifikasi'],
    tags: ['BIM', 'Revit', 'Digital'],
  },
  {
    id: 3,
    title: 'Site Engineer (Struktur)',
    department: 'Engineering',
    location: 'Bekasi, Jawa Barat',
    type: 'Full-time',
    level: 'Junior – Mid',
    salary: 'Rp 7.000.000 – 12.000.000',
    deadline: '20 Mei 2026',
    description: 'Mengawasi pekerjaan struktur di lapangan sesuai gambar kerja dan spesifikasi teknis. Memastikan kualitas pengerjaan, keselamatan kerja, dan dokumentasi progres harian.',
    requirements: [
      'Minimal S1 Teknik Sipil',
      'Pengalaman 2+ tahun sebagai site engineer',
      'Menguasai perhitungan struktur dasar',
      'Familiar dengan software struktur (SAP2000 / ETABS)',
      'Memiliki sertifikasi K3 Konstruksi',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Akomodasi Proyek', 'Uang Makan Harian', 'Bonus Kinerja'],
    tags: ['Struktur', 'Lapangan', 'Engineering'],
  },
  {
    id: 4,
    title: 'Quantity Surveyor (QS)',
    department: 'Estimasi & Biaya',
    location: 'Jakarta Selatan',
    type: 'Full-time',
    level: 'Mid-Level',
    salary: 'Rp 9.000.000 – 15.000.000',
    deadline: '25 Mei 2026',
    description: 'Menyusun estimasi biaya proyek, Bill of Quantity (BoQ), dan laporan cost control. Bertanggung jawab atas keakuratan anggaran proyek dari tahap tender hingga penyelesaian.',
    requirements: [
      'Minimal S1 Teknik Sipil / Teknik Arsitektur',
      'Pengalaman 3+ tahun sebagai QS',
      'Mahir Excel, CostX, atau software estimasi lainnya',
      'Memahami SNI dan harga satuan pekerjaan konstruksi',
      'Detail-oriented dan teliti dalam angka',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Tunjangan Kehadiran', 'Bonus Proyek', 'Asuransi Jiwa'],
    tags: ['QS', 'Estimasi', 'Biaya'],
  },
  {
    id: 5,
    title: 'HSE Officer (K3)',
    department: 'Health, Safety & Environment',
    location: 'Jakarta & Proyek Nasional',
    type: 'Full-time',
    level: 'Mid-Level',
    salary: 'Rp 8.000.000 – 13.000.000',
    deadline: '10 Juni 2026',
    description: 'Mengimplementasikan sistem manajemen keselamatan dan kesehatan kerja di proyek konstruksi. Melakukan inspeksi lapangan, pelatihan safety, dan investigasi insiden.',
    requirements: [
      'Minimal S1/D3 semua jurusan (diutamakan Teknik)',
      'Memiliki sertifikasi AK3 Umum dari Kemnaker RI',
      'Pengalaman 3+ tahun di HSE konstruksi',
      'Familiar dengan OHSAS 18001 / ISO 45001',
      'Tegas dan memiliki jiwa kepemimpinan',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Tunjangan Lapangan', 'APD Lengkap', 'Asuransi Kecelakaan'],
    tags: ['K3', 'HSE', 'Safety'],
  },
  {
    id: 6,
    title: 'Drafter AutoCAD / Revit',
    department: 'Desain & Drafting',
    location: 'Jakarta Selatan',
    type: 'Full-time',
    level: 'Junior',
    salary: 'Rp 5.000.000 – 8.000.000',
    deadline: '1 Juni 2026',
    description: 'Membuat gambar kerja (shop drawing) dan as-built drawing untuk proyek konstruksi menggunakan AutoCAD dan Revit. Berkoordinasi dengan tim desain dan engineering.',
    requirements: [
      'Minimal D3/S1 Teknik Sipil / Arsitektur / Desain',
      'Mahir AutoCAD 2D & 3D',
      'Pengalaman Revit menjadi nilai tambah',
      'Teliti, rapi, dan mampu membaca gambar teknik',
      'Fresh graduate dipersilakan melamar',
    ],
    benefits: ['BPJS Kesehatan & Ketenagakerjaan', 'Meal Allowance', 'Career Development', 'Lingkungan Kerja Kolaboratif'],
    tags: ['AutoCAD', 'Revit', 'Drafting'],
  },
];

export const careerStats = [
  { value: '200+', label: 'Karyawan Aktif' },
  { value: '15+', label: 'Tahun Pengalaman' },
  { value: '98%', label: 'Employee Satisfaction' },
  { value: '4.8/5', label: 'Rating Glassdoor' },
];

export const companyPerks = [
  {
    icon: 'ri-medal-line',
    title: 'Jaminan Karir Jelas',
    desc: 'Jalur karir terstruktur dari junior hingga posisi senior dengan review berkala dan kenaikan gaji tahunan.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Training & Sertifikasi',
    desc: 'Pelatihan teknis, soft skill, dan pembiayaan sertifikasi profesional (SKA, BIM, PMP, dll).',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'BPJS & Asuransi Lengkap',
    desc: 'BPJS Kesehatan, Ketenagakerjaan, serta asuransi jiwa dan kecelakaan untuk seluruh karyawan.',
  },
  {
    icon: 'ri-team-line',
    title: 'Budaya Kolaboratif',
    desc: 'Lingkungan kerja yang inklusif, terbuka, dan berorientasi pada kolaborasi lintas departemen.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Kompensasi Kompetitif',
    desc: 'Gaji di atas rata-rata industri, bonus kinerja proyek, dan tunjangan yang kompetitif.',
  },
  {
    icon: 'ri-global-line',
    title: 'Proyek Skala Nasional',
    desc: 'Kesempatan mengerjakan proyek bergengsi di seluruh Indonesia dengan teknologi konstruksi terkini.',
  },
];
